<template>
  <div class="user_dashboard_calendar">
    <b-datepicker
      inline
      v-model="jsDate"
      :events="events"
      size="is-small"
      @input="dateChanged"
      @change-month="monthChanged"
      @change-year="yearChanged"
    >
    </b-datepicker>
  </div>
</template>

<script>
import dates from "../../../services/dates";

export default {
  name: "UserDashboardCalendar",
  props: {
    date: {
      type: String,
      required: true
    },
    appointments: {
      type: Array,
      default: []
    },
  },
  data() {
    return {
      currentMonth: new Date(this.date).getMonth(),
      currentYear: new Date(this.date).getFullYear(),
    }
  },
  computed: {
    jsDate: {
      get() {
        return new Date(this.date);
      },
      set(newValue) {
        return new Date(newValue);
      }
    },
    events() {
      return this.appointments.map(appointment => {
        return {
          date: new Date(appointment.start_at),
          type: 'is-secondary',
        }
      })
    }
  },
  methods: {
    yearChanged(value) {
      this.currentYear = value
      const date = new Date(this.currentYear, this.currentMonth, 1)
      this.$emit('changed', dates.convertJSDateToISO(date))
    },
    monthChanged(value) {
      this.currentMonth = value
      const date = new Date(this.currentYear, this.currentMonth, 1)
      this.$emit('changed', dates.convertJSDateToISO(date))
    },
    dateChanged(value) {
      this.$emit('input', dates.convertJSDateToISO(value))
    }
  },
}
</script>

<style lang="scss" scoped>
@import '../../../styles/variables/variables';

.user_dashboard_calendar {
  border-bottom: 1px solid $border;
}

:deep(.dropdown-content) {
  box-shadow: none;
}
</style>
